import React, { Component } from 'react';
import {Form, Button, Input, message, Modal, Select, Empty} from 'antd';
import OrdinaryTrees from "../../components/ordinaryTree/OrdinaryTrees";
import FlowchartAndPreview from "../../components/flowchartAndPreview/FlowchartAndPreview";
import { Scrollbars } from "react-custom-scrollbars";
import CmForm from '../../../components/CmForm/CmForm';
import request from "../../../base/request";
import './layout.css'
import {HEADER_HEIGHT} from "../../../constants";
const { Option } = Select;

/**
+ String id;
+ String treeCode;           // 树id
+ String name;               // 名称
+ String parentTreeCode;     // 父节点的tree_id 根节点的父是-1
+ ActivitiApp activitiApp    // 绑定的流程
+ String sourceUrl           // 来源url   不可新增子节点，可以修改删除
+ boolean lock               // 锁定状态   不可新增、修改、删除
 */
class ProcessList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mediaTree: [],
            flowChart: [],
            chooseTreeData: [],
            checkedKeys: [],// 选中的节点
            expandedKeys: [],//展开的节点
            correlationKeys: [],//与选中流程关联的节点
            visible: false,
            clickProcess: {},
            // activitiTypeEnumList: [
            //     { key: 'All', name: '全部' },
            //     { key: 'DEFAULT', name: '写稿' },
            //     { key: 'APPOINTMENT', name: '约稿' },
            //     { key: 'ACTIVITY', name: '活动' },
            //     { key: 'DELIVER', name: '投稿' },
            //     { key: 'OTHER', name: '其他' },
            // ],
            // typeList: [
            //     { key: 'TREE', name: '树' },
            //     { key: 'OTHER', name: '其他媒体' },
            //     { key: 'WEBSITE', name: '网站' },
            //     { key: 'WECHAT', name: '微信' },
            //     { key: 'WEIBO', name: '微博' },
            //     { key: 'COALESCENCE', name: 'COALESCENCE' },
            //     { key: 'DOUYIN', name: '抖音' },
            // ],
            name: '',
            treeCode: '',
            sourceUrl: '',
            activitiTypeEnum: 'All',
            type: 'TREE',
            parentTreeCode: '',
            isAddStatus: false,
        }
    }

    componentWillMount() {
        this.initData();
    }

    componentDidMount() {

    }

    initData() {
        this.initMediaTree();
        this.mediaTreegetApps();
    }
    // 获取树结构数据
    initMediaTree() {
        getMediaTreeActivitiCache((data) => {
            if (data) {
                // let date = [data];
                this.eachEveryOne([data]);

                this.setState({
                    mediaTree: [data]
                });
            }
        });
    }
    // 获取流程选择数据
    mediaTreegetApps(){
        getApps((data) => {
            if (data && data.length) {
                for (let i = 0; i < data.length; i++) {
                    // let key = data[i].key;
                    // getDisplayModelUrl(key, (data)=>{
                    //     console.log("uuuuurl:", data);
                    // });
                    // data[i].url = "/activiti-admin/display/displaymodel.html?definitionId="+data[i].id+"&type=out";
                    data[i].url = data[i].imageInfo;
                    data[i].correlation = false; // 当前选中的关联节点
                }
                this.setState({
                    flowChart: data
                });
            }
        });
    }
    // 重组树结构
    eachEveryOne(data) {
        data.forEach((item, i) => {
            if (item.activitiApp && item.activitiApp.description) {
                item.concatKey = item.activitiApp.key
                item.description = item.activitiApp.description
            }
            if (item.sons && item.sons.length > 0) {
                this.eachEveryOne(item.sons)
            }
        })
    }
    // 保存流程
    saveProcess(process) {
        let treeCodeList = this.flowchartAndPreview.props.chooseTreeData;
        //this.cleanSonsActiviti(meidaTreeCodes);
        updatemMediaTreeActiviti({ treeCodeList, activitiApp: process }, (data) => {
            if (data == true) {
                message.success("业务绑定流程成功");
            } else {
                message.error("业务绑定流程失败，请稍后重试或联系网络管理员！");
            }
            this.initData();
        });
    }

    //清除子节点已经选过的流程
    cleanSonsActiviti = () => {
        getBindByMediaTreeParentCode("DEFAULT", (data) => {
            console.log("data:", data);
        });
    }

    ordinaryTrees;
    flowchartAndPreview;

    render() {
        return (
            <div style={{ overflow: "auto",  height: 'calc(100vh - 100px)',borderRadius:'5px', margin: "15px", backgroundColor: "#ffffff", border: "1px solid #e6e6e6", display: 'flex',padding:'20px'}}>
                {/*业务流程*/}
                {this.renderMediaTreeActivitiCache()}
                {/*流程选择*/}
                {this.renderFlowSelection()}
                {/*弹框*/}
                {this.renderModal()}
            </div>
        )
    }
    // 业务流程
    renderMediaTreeActivitiCache(){
        return(
            <div style={{width: '340px', marginRight: '300px'}} className={'searchStyle'}>
                <div style={{padding: 10}}>业务选择</div>
                <Scrollbars ref={(ref)=>{this.treeScrollbars=ref}} autoHeight autoHeightMax={750}>
                    <OrdinaryTrees
                        autoHide
                        ref={(that) => this.ordinaryTrees = that}
                        dataSource={this.state.mediaTree}
                        title={'name'}
                        showBindName={true}
                        bindNameKey={"activitiApp.name"}
                        keyId={'treeCode'}
                        checkedKeys={this.state.checkedKeys}
                        children={'sons'}
                        showSearch={true}
                        // 默认展开最外层节点
                        expandedKeys={
                            this.state.mediaTree && this.state.mediaTree.length == 1 ?
                                [...this.state.expandedKeys, this.state.mediaTree[0]['treeCode']]
                                : this.state.expandedKeys
                        }
                        correlationKeys={this.state.correlationKeys}
                        onExpand={this.onExpand}
                        placeholder={"请输入业务节点名称"}
                        showFoldBtn={true}
                        checkedKeysAll={(data) => {
                            this.state.expandedKeys.push(data);
                            this.setState({ chooseTreeData: data, checkedKeys: data });
                            // console.log('选中的栏目数据', data)
                        }}
                        addProcess={(currentClickItem) => {
                            this.state.expandedKeys.push(currentClickItem)
                            this.state.flowChart.forEach(item => {
                                item.correlation = false;
                            });
                            this.setState({correlationKeys: [],chooseTreeData: currentClickItem, })
                            this.currentAddProcess(currentClickItem)
                        }}
                        editProcess={(currentClickItem) => {
                            this.currentEditProcess(currentClickItem)
                        }}
                        deleteProcess={(currentClickItem) => {
                            this.currentDeleteProcess(currentClickItem)
                            this.state.flowChart.forEach(item => {
                                item.correlation = false;
                            });
                            this.setState({correlationKeys: []})
                        }}
                        onSearchCall={() => {
                            this.state.flowChart.forEach(item => {
                                item.correlation = false;
                            });
                            this.setState({correlationKeys: []})
                        }}

                    />
                </Scrollbars>
                <style>{`
                    .searchStyle .ant-btn-primary {
                        background: #fafafa !important;
                        border-color: #d9d9d9 !important;
                        color: #7b7b7b!important;
                    }
                    .searchStyle .ant-input-group .ant-input{
                       border-color: #d9d9d9 !important;
                    }
                    .searchStyle .ant-btn-primary:hover, .ant-btn-primary:hover:focus {
                        background: #fafafa !important;
                        border-color: #d9d9d9 !important;
                        color: #7b7b7b!important;
                    }
                    .searchStyle>div>div:nth-child(2){
                        margin-right:6px;
                    }
                    `}</style>
            </div>
        )
    }

    onExpand = expandedKeys => {
        // 刷新滚动条
        this.treeScrollbars && this.treeScrollbars.handleScroll && typeof this.treeScrollbars.handleScroll == 'function' && this.treeScrollbars.handleScroll();
        this.setState({
            expandedKeys,
            autoExpandParent: true,//这个属性要在这里面使用fasle,不然如果子节点打开，关闭父节点关闭不了，点击没反应哦，重要操作。
        });
    };

    // 流程选择
    renderFlowSelection(){
        return(
            <div>
                <div style={{ padding: 10}}>流程选择</div>
                <Scrollbars autoHeight autoHeightMax={750} style={{ marginRight: 10 }} autoHide>
                    <FlowchartAndPreview
                        ref={(that) => this.flowchartAndPreview = that}
                        dataSource={this.state.flowChart}
                        titleKey={'name'}
                        flowchartKey={'key'}
                        previewKey={'url'}
                        chooseTreeData={this.state.chooseTreeData}
                        checkedData={(data) => {
                            console.log('选中的流程数据', data)
                            this.saveProcess(data);
                        }}
                        clickShowBindColumn={(data) => { //点击了关联按钮
                            // 关闭其他关联
                            this.state.flowChart.forEach(item=>{
                                if(item['key']==data['key']) {
                                    item.correlation = !item.correlation;
                                } else {
                                    item.correlation = false;
                                }
                            });
                            let concatId = data['key']; //关联id
                            this.state.correlationKeys = [];
                            if(data['correlation']) {
                                //获取要选的数据
                                this.fundCheckedKeys(this.state.mediaTree, concatId);
                            }
                            //流程图调用流程树数据赋值。
                            // this.state.chooseTreeData = this.state.correlationKeys;
                            this.state.expandedKeys = this.state.correlationKeys;
                            // console.log('当前点击的流程图', data['key'], '关联的树的选中数据', this.state.correlationKeys);
                            this.ordinaryTrees.onChange("search","",()=>{
                                this.setState({expandedKeys:this.state.correlationKeys})
                            });
                            // this.state.checkedKeys = this.state.correlationKeys;
                        }}
                    />
                </Scrollbars>
            </div>
        )
    }
    // 弹框
    renderModal(){
        return(
            <Modal
                title={this.state.isAddStatus ? '添加节点' : '维护节点'}
                visible={this.state.visible}
                onOk={this.handleOkProcess}
                maskClosable={false}
                onCancel={() => {
                    this.setState({ visible: false })
                }}
                width={800}
            >
                <CmForm onSubmit={() => {
                    this.handleOkProcess()
                }}>
                    <Form.Item
                        label="节点名称"
                        required
                    >
                        <Input
                            placeholder="请输入节点名称"
                            value={this.state.name}
                            onChange={(e) => {
                                this.setState({ name: e.target.value })
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label="节点编码"
                        required
                    >
                        <Input
                            disabled={!this.state.isAddStatus}
                            placeholder="请输入节点编码"
                            value={this.state.treeCode}
                            // value={!this.state.isAddStatus ? (this.state.treeCode.split('-').at(-1)) : this.state.treeCode}
                            onChange={(e) => {
                                this.setState({
                                    treeCode: e.target.value,
                                })
                            }}
                        />
                    </Form.Item>
                    {
                        this.state.isAddStatus || this.state.oldSourceUrl ?
                            <Form.Item
                                label="同步获取远程节点"
                            >
                                <Input
                                    placeholder="请输入远程节点"
                                    value={this.state.sourceUrl}
                                    onChange={(e) => {
                                        this.setState({
                                            sourceUrl: e.target.value,
                                        })
                                    }}
                                />
                            </Form.Item> : ""
                    }

                </CmForm>
            </Modal>
        )
    }
    // 点击流程图以后关联流程树数据交互
    fundCheckedKeys(data, concatId) {
        let childKey = 'sons' //树子节点字段键值
        let keyId = 'treeCode'//树的标识
        let concatIds = 'concatKey'//树的标识Id
        if (data && data.length > 0) {
            data.forEach((item) => {
                if (item[concatIds]) {
                    if (item[concatIds] === concatId) {
                        this.state.correlationKeys.push(item[keyId])
                    }
                }
                this.fundCheckedKeys(item[childKey], concatId)
            })
        }
    }
    //新增流程
    currentAddProcess(item) {
        this.initFirstData();
        this.state.clickProcess = item;
        this.setState({
            visible: true,
            isAddStatus: true,
            sourceUrl: "",
            name: "",
            treeCode: ""
        });
    }
    //编辑流程
    currentEditProcess(item) {
        this.initFirstData();
        this.state.clickProcess = item;
        this.setState({
            visible: true,
            isAddStatus: false,
            treeCode: item.treeCode,
            name: item.name,
            sourceUrl: item.sourceUrl,
            oldSourceUrl: item.sourceUrl
        });
    }
    //删除流程
    currentDeleteProcess(item) {
        deleteByTreeCode(item.treeCode, (res) => {
            message.success('业务删除成功');
            this.initMediaTree();
        });
    }
    //保存
    handleOkProcess = () => {
        if (this.state.isAddStatus) {
            this.addProcess()
        } else {
            this.editProcess()
        }
    };
    //新增流程
    addProcess() {
        message.destroy();
        if (this.state.name.trim().length < 1) {
            message.error('未输入节点名称！');
            return false
        }
        if (this.state.treeCode.trim().length < 1) {
            message.error('未输入节点编码！');
            return false
        }
        if (this.state.treeCode.trim().length >100) {
            message.error('节点编码长度范围在1~100之间！');
            return false
        }
        if (this.state.name.trim().length >30) {
            message.error('节点名称长度范围在1~30之间！');
            return false
        }
        let {sourceUrl,treeCode}=this.state;
        if(sourceUrl&&sourceUrl.length){
            if (!(
                (/^(https|http):\/\//g.test(sourceUrl))
                // && !(/[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5|\uff0d \uff3f|\u002d]/g.test(sourceUrl))
                && !(/[\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7]/g.test(sourceUrl))
                ||(sourceUrl=="")
            )) {
                message.error('远程节点地址格式错误，请重新填写！');
                return false
            }
        }

        if (!(/^[A-Za-z0-9_:]+$/g.test(treeCode.trim()))) {
            message.error('节点编码只可填写字母、数字、下划线及冒号，限制输入100个字符！');
            return false
        }
        let treeCodeList = this.state.clickProcess.sons.map(item => item.treeCode.split('-').pop());
        if (treeCodeList.indexOf(this.state.treeCode.trim()) != -1) {
            message.error('节点编码重复，请重新填写！');
            return false
        }
        this.setState({ visible: false });
        let params = {
            "name": this.state.name,
            "treeCode": this.state.clickProcess.treeCode + '-' + this.state.treeCode,
            "sourceUrl": this.state.sourceUrl==""?null:this.state.sourceUrl,
            "parentTreeCode": this.state.clickProcess.treeCode,
        };
        addActivitiBindTree(params, (res) => {
            message.success('添加成功');
            this.state.expandedKeys.push(this.state.clickProcess.treeCode);
            this.initMediaTree();
        });
    }
    //编辑流程
    editProcess() {
        message.destroy();
        if (this.state.name.trim().length < 1) {
            message.destroy();
            message.error('未输入节点名称！');
            return false
        }
        if (this.state.name.trim().length > 30) {
            message.destroy();
            message.error('节点名称长度范围在1~30之间！');
            return false
        }
        let {sourceUrl}=this.state;
        if(sourceUrl&&sourceUrl.length){
            if (!(
                (/^(https|http):\/\//g.test(sourceUrl))
                // && !(/[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5|\uff0d \uff3f|\u002d]/g.test(sourceUrl))
                && !(/[\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7]/g.test(sourceUrl))
            )) {
                message.error('远程节点地址格式错误，请重新填写！');
                return false
            }
        }
        this.setState({ visible: false });
        let params = {
            "name": this.state.name,
            "id": this.state.clickProcess.id,
            "sourceUrl":this.state.sourceUrl,
        };
        editActivitiBindTree(params, (res) => {
            message.success('修改成功');
            this.state.oldSourceUrl="";
            this.initMediaTree();
        });
    }
    // 初始化数据
    initFirstData() {
        this.state.name = '';
        this.state.treeCode = '';
        this.state.activitiTypeEnum = 'All';
        this.state.type = 'TREE';
        this.state.parentTreeCode = '';
    }

}

export default ProcessList;



/**
 * 流程绑定树节点添加
 * @param {*} param0
 * @param {*} callBack
 */
export const addActivitiBindTree = (
    {
        treeCode,
        name,
        parentTreeCode,
        sourceUrl
    } = {},
    callBack
) => {
    request({
        url: "/cm-sites-sys/activitiBindTree/add",
        method: "POST",
        body: {
            treeCode,
            name,
            parentTreeCode,
            sourceUrl
        },
        contentType: "json",
        callBack
    });
}


/**
 * 流程绑定树节点修改
 * @param {*} param0
 * @param {*} callBack
 */
export const editActivitiBindTree = (
    {id,name,sourceUrl}={},
    callBack
)=>{
    request({
        url:"/cm-sites-sys/activitiBindTree/edit",
        method: "POST",
        body:{
            id,
            name,
            sourceUrl
        },
        contentType: "json",
        callBack
    })
}

/**
 * 流程绑定树节点删除
 * @param {*} treeCode
 * @param {*} callBack
 */
export const deleteByTreeCode = (treeCode,callBack)=>{
    request({
        url:"/cm-sites-sys/activitiBindTree/deleteByTreeCode",
        method:"POST",
        body:{
            treeCode
        },
        callBack
    });
}

/**
 * 获取树数据
 * @param {*} callBack
 */
export const getMediaTreeActivitiCache = (callBack) => {
    let url = "/cm-sites-sys/activitiBindTree/findActivitiTree";
    request({
        url,
        callBack
    });
};
/**
 * 获取流程选择数据
 * @param {*} callBack
 */
export const getApps = (callBack) => {
    let url = "/cm-sites-activiti/activitiAdmin/getAppsInfo";
    request({
        url, callBack
    });
};
/**
 * 获取树业务选择数据
 * @param {*} callBack
 */
export const updatemMediaTreeActiviti = (jsonObject, callBack) => {
    let url = "/cm-sites-sys/activitiBindTree/bindActivitiApp";
    if(jsonObject&&jsonObject.treeCodeList instanceof Array){
        request({
            url, callBack, contentType: "json", method: 'post', body: jsonObject
        });
    }else{
        message.error('请选择左侧业务节点后再绑定流程！')
    }
};
/**
 * 获取树父节点
 * @param {*} callBack
 */
export const getBindByMediaTreeParentCode = (mediaTreeParentCode, callBack) => {
    let url = "/cm-sites-sys/mediaTreeActiviti/getBindByMediaTreeParentCode";
    request({
        url, callBack, method: 'post', body: { mediaTreeParentCode }
    });
};
/**
 *
 * @param {*} callBack
 */
export const getDisplayModelUrl = (key, callBack) => {
    let url = "/cm-sites-activiti/activitiAdmin/getDisplayModelUrl";
    request({
        url, callBack, method: 'post', body: { key }
    });
};

